import gql from 'graphql-tag'

export const checkATPQuery = gql`
  query ($products: [stockproducts]!) {
    checkProductsStock(
      products: $products
    ) {
      success
      message
      failed_items {
          sku
          reason,
          max_available_quantity
      }
    }
  }
`
